module.exports = __webpack_public_path__ + "img/06.6a163f3f.png";